module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-medical-a23cf5e1.svg";